import React from "react";

import Pagetrans from "./pagetrans";
import mail from "../svg/at.892a24c1.svg";
import phone from "../svg/phone.786a0776.svg";
import github from "../svg/github.1413f4f4.svg";
import twitter from "../svg/twitter.5c745d7b.svg";
import linkedin from "../svg/linkedin.ac16119e.svg";

const Contactpage = () => {
  return (
    <main className="contact py-lg-5 titled-section trans ">
      <Pagetrans className="container py-lg-3 py-xl-5">
        <h1 className="section-title text-uppercase">
          get in <span className="decorate">touch</span>{" "}
          <span className="bg text-uppercase d-none d-md-block">contact</span>
        </h1>
        <div className="row">
          <div className="col-12 section col-lg-4">
            <h2 className="title text-uppercase text-light">Don't be shy</h2>
            <p className="poppins-font mb-3">
              Feel free to get in touch with me. I am always open to discussing
              new projects, creative ideas or opportunities to be part of your
              visions.
            </p>
            <div className="social-group mail">
              <p className="icon">
                <img src={mail} alt="mail icon" />
              </p>
              <p className="data">
                <span className="text-uppercase">Mail me</span>
                <span>sparklinsparky@gmail.com</span>
              </p>
            </div>
            <div className="social-group phone">
              <p className="icon">
                <img src={phone} alt="phone icon" />
              </p>
              <p className="data">
                <span className="text-uppercase">call me</span>
                <span>
                  <span>+234</span>
                  <span>816</span> <span>245</span> <span>2124</span>
                </span>
              </p>
            </div>
            <div className="socials">
              <a
                href="https://github.com/mhizterkeyz"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={github} alt="github icon" />
              </a>
              <a
                href="https://twitter.com/mhizterkeyz"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitter} alt="twitter icon" />
              </a>
              <a
                href="https://www.linkedin.com/in/emmanuelmenyaga"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedin} alt="linkedin icon" />
              </a>
            </div>
          </div>
          <div className="col-12 col-lg-8">
            <form className="contact-form" autoComplete="false">
              <div className="row">
                <div className="col-12 col-md-4">
                  <input type="text" name="name" placeholder="YOUR NAME " />
                </div>
                <div className="col-12 col-md-4">
                  <input type="email" name="email" placeholder="YOUR EMAIL " />
                </div>
                <div className="col-12 col-md-4">
                  <input
                    type="text"
                    name="subject"
                    placeholder="YOUR SUBJECT "
                  />
                </div>
                <div className="col-12">
                  <textarea
                    name="message"
                    placeholder="YOUR MESSAGE"
                  ></textarea>
                  <button type="submit" className="btn btn-primary">
                    Send Message
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Pagetrans>
    </main>
  );
};

export default Contactpage;
